import { render, staticRenderFns } from "./FicheSuiviDocuments.vue?vue&type=template&id=082cd4e0&"
import script from "./FicheSuiviDocuments.vue?vue&type=script&lang=js&"
export * from "./FicheSuiviDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports